import { put, select } from "redux-saga/effects";
import { IntegrationService } from "../integration.service";
import { updateMailchimpConfigFailure, updateMailchimpConfigSuccess } from "../actionCreators";
import { IUpdateMailchimpConfigRequestData } from "../types";

export function* updateMailchimpConfigSaga(action: {
    type: string;
    payload: IUpdateMailchimpConfigRequestData;
}): Generator<any, void, any> {
    try {
        const { listId, fields } = action.payload;
        const formId: string = yield select(state => state.forms.current._id);
        const data = { listId, fields };
        const response = yield IntegrationService.updateMailchimpConfig(formId, data);
        if (response.data.success) {
            yield put(updateMailchimpConfigSuccess(response.data.data.config.mailChimp));
        } else {
            yield put(updateMailchimpConfigFailure(response.message || "Failed to update Mailchimp Sheets config"));
        }
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to update Mailchimp Sheets";
        console.error("Error updating Mailchimp Sheets config:", error);
        yield put(updateMailchimpConfigFailure(errorMessage));
    }
}
